import { createReducer } from "@reduxjs/toolkit";

const userData = JSON.parse(sessionStorage.getItem("user"));

const token = sessionStorage.getItem("subscriberToken")
  ? sessionStorage.getItem("subscriberToken")
  : sessionStorage.getItem("token");

const forgetOtpData = JSON.parse(sessionStorage.getItem("forget_password_otp"));

const initialstate = {
  loginStatus: sessionStorage.getItem("loginStatus")
    ? sessionStorage.getItem("loginStatus")
    : false,

  emailVerified: false,
  phoneVerified: false,

  user: {
    first_name: userData && userData.first_name ? userData.first_name : "",
    last_name: userData && userData.last_name ? userData.last_name : "",
    email: userData && userData.email ? userData.email : "",
    mobile: userData && userData.mobile ? userData.mobile : "",
    password: userData && userData.password ? userData.password : "",
    password2: userData && userData.password2 ? userData.password2 : "",
    pin_code: userData && userData.pin_code ? userData.pin_code : "",
    city: userData && userData.city ? userData.city : "",
    state: userData && userData.state ? userData.state : "",
    pan_card: userData && userData.pan_card ? userData.pan_card : "",
    address_line_1:
      userData && userData.address_line_1 ? userData.address_line_1 : "",
    address_line_2:
      userData && userData.address_line_2 ? userData.address_line_2 : "",
  },

  token: token ? token : "",

  otpForgetePassword: sessionStorage.getItem("forget_password_otp")
    ? {
        username: forgetOtpData.username,
        otp_id: forgetOtpData.otp_id,
        verified: forgetOtpData.verified,
      }
    : {
        username: null,
        otp_id: null,
        verified: false,
      },
};

export const customReducer = createReducer(initialstate, {
  login: (state) => {
    state.loginStatus = true;
  },

  logout: (state) => {
    if (sessionStorage.getItem("subscriberToken")) {
      sessionStorage.removeItem("subscriberToken");
      sessionStorage.removeItem("subscriberName");
      sessionStorage.removeItem("selectedRadio");
      sessionStorage.removeItem("SubscriberPermissions");
      sessionStorage.removeItem("SubscriberData");
      sessionStorage.removeItem("subscriberId");
      sessionStorage.removeItem("selectedId");
      sessionStorage.removeItem("subFinYearID");
      sessionStorage.removeItem("caa_status");
      sessionStorage.removeItem("corporate_action");
      sessionStorage.removeItem("ca_master_scrip");
      sessionStorage.removeItem("CorporateActionMaster");
      sessionStorage.removeItem("ex_to");
      sessionStorage.removeItem("ex_from");
      sessionStorage.removeItem("ex_from");
      sessionStorage.removeItem("ex_from");
      sessionStorage.removeItem("ex_from");
      sessionStorage.removeItem("ex_from");
      sessionStorage.removeItem("EligibleTaskId");
      sessionStorage.removeItem("CapitalGLDetailedTaskId");
      sessionStorage.removeItem("CapitalGLSummaryTaskId");
      sessionStorage.removeItem("F&OPositionTaskId");
      sessionStorage.removeItem("F&OPLTaskId");
      sessionStorage.removeItem("TaskId");
      sessionStorage.removeItem("taskStatus");
    } else {
      state.loginStatus = false;
      state.user = {};
      sessionStorage.clear();
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
    }
  },

  setUserData: (state, action) => {
    state.user = {
      ...state.user,
      ...action.payload,
    };
    sessionStorage.setItem("user", JSON.stringify(state.user));
  },

  setVerifyEmailStatus: (state, action) => {
    state.emailVerified = action.payload.status;
    sessionStorage.setItem("email_verified", state.emailVerified);
  },

  setVerifyPhoneStatus: (state, action) => {
    state.phoneVerified = action.payload.status;
    sessionStorage.setItem("phone_verified", state.phoneVerified);
  },

  setAuthToken: (state, action) => {
    state.token = action.payload.token;
    sessionStorage.setItem("token", state.token);
  },

  setForgetOtp: (state, action) => {
    state.otpForgetePassword.otp_id = action.payload.otp_id;
    state.otpForgetePassword.username = action.payload.username;
    state.otpForgetePassword.verified = action.payload.verified;
    sessionStorage.setItem(
      "forget_password_otp",
      JSON.stringify(state.otpForgetePassword),
    );
  },
});
